var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddressBillingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.429 27.285a.857.857 0 000 1.714h2.857a.857.857 0 100-1.714h-2.857zm-18-11.714a3.143 3.143 0 013.143-3.143H31a3.143 3.143 0 013.143 3.143v1.437a4.286 4.286 0 014 4.277v12a4.285 4.285 0 01-4.286 4.286H16.72a4.286 4.286 0 01-4.286-4.286v-12h-.004v-5.429h.012a3.168 3.168 0 01-.012-.285zm21.428 3.142h-19.71v14.572a2.571 2.571 0 002.572 2.571h17.138a2.571 2.571 0 002.572-2.571v-12a2.571 2.571 0 00-2.572-2.572zm-1.428-3.142A1.43 1.43 0 0031 14.142H15.572a1.429 1.429 0 100 2.857h16.857v-1.428z",
    fill: "#FFA700"
  })));
}

export default SvgAddressBillingIcon;